const Step4Form = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  return (
    <div className="flex flex-col gap-6 p-4 rounded-lg text-left bg-primary-green">
      <h3 className="text-white text-xl md:text-3xl font-bold">
        ¡Ya casi eres cliente Omova Carbon Fiber!
      </h3>

      <p className="text-white text-xl">
        Por último cuéntanos en qué tipo de proyectos planeas usar nuestros
        productos:*
      </p>
      {/* Required field */}
      <textarea
        rows={3}
        placeholder="Pienso usar su fibra de carbono para..."
        value={data.projects}
        onChange={(e) => handleChange("projects", e.target.value)}
        className="w-full px-3 py-2 rounded text-black text-md"
      />

      <p className="text-white text-xl">
        Compártenos alguna duda o comentario: (opcional)
      </p>
      {/* Optional field */}
      <textarea
        rows={3}
        placeholder="Comentario..."
        value={data.comment}
        onChange={(e) => handleChange("comment", e.target.value)}
        className="w-full px-3 py-2 rounded text-black text-md"
      />

      <p className="text-white text-xl">
        Al enviar tu formulario nos pondremos en contacto contigo para más
        información
      </p>
    </div>
  );
};

export default Step4Form;
